const templateUrl = require('./../views/partials/dashboard-tabs.html');
const dashboardTabsDirective = () => {
  return {
    templateUrl,
    restrict: 'E',
    link: function(scope, el, attrs) {
      var $body = $('html, body');
      el.find('.scroll_nav_tab').on('click', function() {
        var offset = el.offset().top;
        $body.animate({ scrollTop: offset });
      });
    }
  }
};
export default dashboardTabsDirective;



// WEBPACK FOOTER //
// ./js/containers/dashboard/directives/dashboardTabs.js